module.exports = __webpack_public_path__ + "media/images/ico-plus-orange-a8b357cb.svg";